<template>
    <div class="pt-5">
        <v-row
            class="fill-height mb-5"
            align="center"
            justify="center"
        >
            <v-row
                align="center"
                justify="center"
                v-if="!file"
                class="prompt"
                @click="handleClick"
            >
                <v-icon x-large>add</v-icon>
                Click to select .csv
            </v-row>
            <v-progress-circular
                indeterminate
                color="grey"
                v-if="file && loading"
            />
            <input
                data-testid="unit-management-csv-input"
                class="unit-management-csv-input"
                type="file"
                ref="csvInput"
                name="facility_unit_csv"
                style="display: none;"
                @change="handleChange"
            >
        </v-row>

        <v-data-table
            :headers="headers"
            :items="currentPriceList"
            :options.sync="pagination"
        >
            <template v-slot:body="{ items }">
                <transition-group
                    name="scroll-y-transition"
                    tag="tbody"
                    v-if="items.length"
                >
                    <tr v-for="item in items" :key="item.unit_id_first_available">
                        <td>{{ item.type_name }}</td>
                        <td>{{ item.width }}</td>
                        <td>{{ item.length }}</td>
                        <td>{{ item.rate }}</td>
                        <td>{{ item.floor }}</td>
                        <td>{{ item.alarm }}</td>
                        <td>{{ item.power }}</td>
                        <td>{{ item.inside }}</td>
                        <td>{{ item.mobile }}</td>
                        <td>{{ item.climate }}</td>
                        <td>{{ item.promotion_text }}</td>
                    </tr>
                </transition-group>
                <tr v-else>
                    <td colspan="12" style="text-align: center">
                        No price list found.
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { unitManagementHeaders } from "@/helpers/facility/unit-mgmt-data-table-headers";

export default {
  data() {
    return {
      file: false,
      loading: false,
      headers: unitManagementHeaders,
      pagination: {
        itemsPerPage: -1
      }
    };
  },

  computed: {
    currentPriceList() {
      if (this.$store.state.facility.currentFacility.price_list && this.$store.state.facility.currentFacility.price_list.price_list) {
        return this.$store.state.facility.currentFacility.price_list.price_list;
      }

      return [];
    }
  },

  methods: {
    handleClick() {
      this.$refs.csvInput.click();
    },

    handleChange() {
      this.loading = true;
      this.file = this.$refs.csvInput.files[0];

      const formData = new FormData();
      formData.append("units", this.file);

      this.$store.dispatch("uploadFacilityUnits", formData)
        .finally(() => {
          this.file = false;
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
    .prompt {
        cursor: pointer;
        height: 100%;
    }
</style>
